<script>
    import { onMount } from 'svelte';
    let loadingAnim;
    onMount(() => {
        let lottieAnim = bodymovin.loadAnimation({
            container: loadingAnim,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: "/assets/loading-Anim.json"
        })
    });
</script>
<div id="anim-holder">
    <div id="loading" bind:this={loadingAnim}></div>
</div>
<style lang="scss">
    #anim-holder {
      width: 100vw;
      height: calc(100vh - var(--header-footer-height));
      position: fixed;
      top: var(--header-footer-height);
      padding-bottom: var(--header-footer-height);
      left: 0;
      background-color: rgba(239, 239, 239, .8);
      display: flex;
      z-index: 999;
      #loading {
        max-width: 20vw;
        margin: auto;
      }
    }
</style>